import React from 'react';
import './DeleteConfirmModal.css';

const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, items }) => {
  if (!isOpen) return null;

  const itemCount = items ? items.length : 0;
  const itemType = itemCount === 1 
    ? (items[0]?.isFolder ? 'folder' : 'file')
    : 'items';
  const itemName = itemCount === 1 ? items[0]?.name : null;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <div className="delete-confirm-modal-overlay" onClick={handleCancel}>
      <div className="delete-confirm-modal" onClick={(e) => e.stopPropagation()}>
        <div className="delete-confirm-modal-header">
          <i className="fas fa-exclamation-triangle"></i>
          <h2>Delete {itemType === 'items' ? 'Items' : itemType === 'folder' ? 'Folder' : 'File'}?</h2>
        </div>
        
        <div className="delete-confirm-modal-content">
          <p>
            Are you sure you want to delete {itemCount === 1 ? (
              <strong>"{itemName}"</strong>
            ) : (
              <strong>{itemCount} {itemType}</strong>
            )}?
          </p>
          <p className="delete-confirm-warning">
            This action will mark the {itemCount === 1 ? itemType : 'items'} as deleted. 
            The {itemCount === 1 ? itemType : 'items'} will be removed from the file list.
          </p>
        </div>

        <div className="delete-confirm-modal-footer">
          <button 
            className="delete-confirm-btn cancel-btn" 
            onClick={handleCancel}
          >
            No
          </button>
          <button 
            className="delete-confirm-btn confirm-btn" 
            onClick={handleConfirm}
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;

